import MmenuLight from 'mmenu-light';

const MenuMobile = {
  setMenuMobile: function () {
    const mmenuWrapper = document.querySelector('#mm-menu-mobile');
    const mmenu = new MmenuLight(mmenuWrapper);

    //precisa do navigation e do drawer
    const navigator = mmenu.navigation({
      title: 'Menu',
      slidingSubmenus: false,
      selected: '-active',
    });

    const drawer = mmenu.offcanvas();

    document.querySelector('[data-action="open-menu-mobile"]').addEventListener('click', (e) => {
      e.preventDefault();

      drawer.open();
    });

    document.querySelector('[data-action="close-menu-mobile"]').addEventListener('click', (e) => {
      e.preventDefault();

      drawer.close();
    });

    window.mmenu = drawer;
  },

  handleArrows: function (mmenuEl, mutations, observer) {
    mutations.forEach((mutation) => {
      let target = mutation.target;
      let listItem = target.closest('li');
      observer.disconnect();

      if (listItem) {
        if (target.classList.contains('mm-spn--open')) {
          listItem.classList.add('-active');
        } else {
          listItem.classList.remove('-active');
        }
      }
    });

    observer.observe(mmenuEl, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    // listItems.forEach((listItem) => {
    //   let parentListItem = listItem.closest('li').c;
    // });
  },

  watchMmenu: function () {
    const mmenuEl = document.getElementById('mm-menu-mobile');

    var observer = new MutationObserver(function (mutations) {
      // const targetElement = mutations[0].target;
      // if (targetElement.getAttribute('data-ignore-mutation') == 'true') return;

      // Carrinho aberto
      if (document.querySelector('.mm-ocd.mm-ocd--left.mm-ocd--open')) {
        MenuMobile.handleArrows(mmenuEl, mutations, observer);
      }
    });

    observer.observe(mmenuEl, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  },

  init: function () {
    const _this = this;

    _this.setMenuMobile();
    _this.watchMmenu();
  },
};

MenuMobile.init();
